export default {
    path: '/feelist',
    meta: {
        title: '能源账单',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/feelist`),
}


// WEBPACK FOOTER //
// ./src/views/FeeList/router.js